export default [
  {
    path: '/modules/financial/importPage',
    redirect: '/modules/financial/files',
    component: () => import('@/views/modules/financial/files/AccountsFiles.vue'),
    meta: {
      action: [
        'ROLE_IMPORTACAO_FINAN_TXT_CONSULTAR',
        'ROLE_IMPORTACAO_INSS_CONSULTAR',
        'ROLE_DYNAMIC_IMPORT_CONSULTAR',
      ],
      resource: 'ACL',
      pageTitle: 'Arquivos',
      breadcrumb: [
        {
          text: 'Financeiro',
        },
      ],
    },
    children: [
      {
        path: 'neos',
        name: 'importPageNeos',
        component: () => import(
          '@/views/modules/financial/files/grid/AccountFilesNeosGrid.vue'
        ),
        meta: {
          pageTitle: 'Arquivos',
          action: 'ROLE_IMPORTACAO_FINAN_TXT_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Arquivos',
            },
          ],
        },
      },
      {
        path: 'inss',
        name: 'importPageInss',
        component: () => import(
          '@/views/modules/financial/files/grid/AccountFilesInssGrid.vue'
        ),
        meta: {
          pageTitle: 'Arquivos',
          action: 'ROLE_IMPORTACAO_INSS_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Arquivos',
            },
          ],
        },
      },
      {
        path: '/dynamic',
        name: 'importPageGeneric',
        component: () => import(
          '@/views/modules/financial/files/grid/GenericAccountImport.vue'
        ),
        meta: {
          pageTitle: 'Importador Dinâmico',
          action: 'ROLE_DYNAMIC_IMPORT_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Importador Dinâmico',
            },
          ],
        },
      },
      {
        path: '/dynamic-layouts',
        name: 'importLayoutSettings',
        component: () => import('@/views/modules/financial/files/grid/ImportLayoutGrid.vue'),
        meta: {
          pageTitle: 'Configuração de Layouts',
          action: 'ROLE_DYNAMIC_IMPORT_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Layouts',
            },
          ],
        },
      },
      {
        path: '/dynamic-layouts/:id',
        name: 'importLayoutEditor',
        component: () => import('@/views/modules/financial/files/grid/ImportLayoutEditor.vue'),
        meta: {
          pageTitle: 'Editor de Layout',
          action: 'ROLE_DYNAMIC_IMPORT_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Editar Layout',
            },
          ],
        },
      },
    ],
  },
]
